/**
 * @module AuthSaga
 */

import store from "../store";
import { tableActionTypes } from "./saga";

/**
 * set selected table
 * @param {string} table
 * @param {string} id
 */
export function setSelectedTableData(table, data) {
  store.dispatch({
    type: tableActionTypes.SET_SELECTED_TABLE_DATA,
    payload: { table: table, data: data }
  });
}

/**
 * set selected table filter
 * @param {string} table
 * @param {string} filter
 */
export function setTableFilter(table, filter) {
  store.dispatch({
    type: tableActionTypes.SET_TABLE_FILTER,
    payload: { table: table, filter: filter }
  });
}

export function setTableSort(table, sort) {
  store.dispatch({
    type: tableActionTypes.SET_TABLE_SORT,
    payload: { table: table, sort: sort }
  });
}

export function setTablePageNumber(table, pageNumber) {
  store.dispatch({
    type: tableActionTypes.SET_TABLE_PAGE_NUMBER,
    payload: { table: table, pageNumber: pageNumber }
  });
}

export function setTableSearchKey(tableName, searchKey) {
  store.dispatch({
    type: tableActionTypes.SET_TABLE_SEARCH_KEY,
    payload: { tableName: tableName, searchKey: searchKey }
  });
}
